import { oidcEarlyInit } from "oidc-spa/entrypoint";
import { browserRuntimeFreeze } from "oidc-spa/browser-runtime-freeze";


const { shouldLoadApp } = oidcEarlyInit({
BASE_URL: "/",

securityDefenses: {
...browserRuntimeFreeze({}),


}
});

if (shouldLoadApp) {
import("./index.tsx?oidc-spa-original=true");
}